import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

// Define the schema for a single element of the array
export const tagwallAccountsReceivableAgingXlsxFileDataElementSchema = yup
  .object({
    customerName: yup.string().nullable().optional(),
    customerId: yup.string().nullable().optional(),
    invoice: yup.string().nullable().optional(),
    propNumber: yup.string().nullable().optional(),
    propDescription: yup.string().nullable().optional(),
    date: yup.string().nullable().optional(),
    customerPo: yup.string().nullable().optional(),
    originalAmount: yup.string().nullable().optional(),
    balance: yup.string().nullable().optional(),
    deposits: yup.string().nullable().optional(),
  })
  .required()

export const tagwallAccountsReceivableAgingXlsxFileDataSchema = yup
  .object({
    asOfDate: yup.string().required(),
    rows: yup.array().of(tagwallAccountsReceivableAgingXlsxFileDataElementSchema).required(),
  })
  .required()

export type TagwallAccountsReceivableAgingXlsxFileData = yup.InferType<
  typeof tagwallAccountsReceivableAgingXlsxFileDataSchema
>

// Type for a single element of the array
export type TagwallAccountsReceivableAgingXlsxFileDataElement = yup.InferType<
  typeof tagwallAccountsReceivableAgingXlsxFileDataElementSchema
>

// Use the element type for the mappings
type RequiredFileData = MakeRequiredAndNullable<TagwallAccountsReceivableAgingXlsxFileData>

const rowMappings: MakeRequiredAndNullable<TagwallAccountsReceivableAgingXlsxFileDataElement> = {
  customerName: '6f9ad9a6-b56d-432c-a8aa-50aabf74c81d',
  customerId: 'a957ecb5-2df4-4caa-b28f-323cd5c3d4ce',
  invoice: 'cbc2aac6-a090-42eb-bd71-90257ea107e8',
  propNumber: 'f38b9941-95b7-4aec-96ef-5e20ee7ed574',
  propDescription: '3890050f-6e5e-4287-965d-3c6ae727448b',
  date: 'c12e6ab2-3b57-46fc-aef1-f872a0a895a5',
  customerPo: '919d75d8-691b-43bc-8bd6-6a48d1321309',
  originalAmount: '90ac77ee-0219-45a8-a59b-7109596c455a',
  balance: 'ea59536f-b765-4cc2-9a9b-a58c3c6dc9ba',
  deposits: '2b8f3c4e-7d9a-4b1c-8e5f-6a3b2c9d8e7f',
}

export const tagwallAccountsReceivableAgingXlsxFileMappings: RequiredFileData = {
  asOfDate: '67bda4f4-500b-4705-8e62-5984fae0a7ba',
  rows: [rowMappings],
}
